import { render } from "./KSClusterHistory.vue?vue&type=template&id=34315990"
import script from "./KSClusterHistory.vue?vue&type=script&lang=js"
export * from "./KSClusterHistory.vue?vue&type=script&lang=js"

import "./KSClusterHistory.vue?vue&type=style&index=0&id=34315990&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__